import { styled } from 'styled-components';
import { FontSize } from 'commons';

export const TableContainer = styled.div`
  display: grid;
  overflow: auto;
`;

const headerBorderRadius = '8px';

export const Table = styled.table<{ $hasMinWidth: boolean }>`
  min-width: ${({ $hasMinWidth }) => ($hasMinWidth ? '1100px' : 'unset')};
  border-collapse: collapse;
  font-size: ${FontSize.font14};

  th,
  td {
    text-align: start;
    padding: 16px;
  }

  thead {
    tr {
      background-color: ${({ theme }) => theme.neutral_200};
    }
    th:first-child {
      border-radius: ${headerBorderRadius} 0 0 ${headerBorderRadius};
    }

    th:last-child {
      border-radius: 0 ${headerBorderRadius} ${headerBorderRadius} 0;
    }
  }
`;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 8px;
  gap: 16px;
`;
